import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App);
app.mount('#app');

import Layui from '@layui/layui-vue'
import '@layui/layui-vue/lib/index.css'
// app.use(Layui);

// vue-tooltip
import FloatingVue from 'floating-vue';
app.use(FloatingVue);
import 'floating-vue/dist/style.css';

import './style.css'
